import { Fragment, useState } from 'react';
import classes from './Layout.module.css';

const Layout = (props) => {
  return (
    <Fragment>
      <div className={classes['container-fluid']}>{props.children}
      </div>
    </Fragment>
  );
};

export default Layout;